export default __webpack_public_path__ + "static/media/fire.87adf02a.svg";